import { Card, Heading, Spinner } from "@chakra-ui/react"

const LoadingMessage = () => {
    return(
        <Card align='center'>
            <Heading size='xl' marginBottom={5}>Loading...</Heading>
            <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='blue.500'
                size='xl'
            />
        </Card>
    )
}

export default LoadingMessage;